import { useEffect, useState } from "react";
import searchApi from '@/service/modules/schemeApi'
import dayjs from 'dayjs'
import DefaultLayout from "@/components/DefaultLayout"
import styles from "@/styles/scheme.module.scss"
import SliderBarRight from "@/components/SliderBarRight";
import SliderBarLeft from "@/components/SliderBarLeft";
import ShopInfo from "@/components/ShopInfo"
import BreadCrumEle from "@/components/global/BreadCrum";
import FilterBarScheme from '@/components/FilterBarScheme'
import { Image, Empty, Skeleton } from "antd"
import GoodsComponentWithDiscountNew from "@/components/GoodsComponentWithDiscountNew";
import { useRouter } from "next/router";
import GoogleADSense from "@/components/GoogleADSense"
import InfiniteScroll from "react-infinite-scroll-component";
import { fillterBarDictionary } from "@/utils/dictionary"
import Head from "next/head"
import Script from "next/script";
import GoogleOneTap from "@/components/GoogleOneTap";
interface BreadcrumbItem {
  name: string;
  url: string;
  current: boolean;
}

interface BreadCrum {
  breadCrumb: Array<BreadcrumbItem>
  categoryID: string
}

interface FilterItems {
  categoryID: number;
  count: number;
  icon: string;
  name: string;
  parent: number;
  url: string;
}
interface sidebarFilterItem {
  key: string
  title: string
  items: Array<FilterItems>
}
interface Sidebar {
  sidebarFilter: Array<sidebarFilterItem>
}

interface PageList {
  currentPage: number;
  items: any[]
  lastPage: number;
  perPage: number;
  total: number;
}
interface SchemeInfo {
  pageList: PageList
  scheme: {
    title: string;
    metaDescription: string;
    metaKeywords: string;
    logoUrl: string
  }
}
interface Props {
  pageList: SchemeInfo;
  schemeBreadcrumb: BreadCrum;
  schemeSidebar: Sidebar;
}

interface DAMNU_ENABLE {
  [key: string]: any, // 字段扩展声明
}

const getSchemeList = async (id: string, params: any) => {
  try {
    const data = await searchApi.getSchemeList(id, params)
    return {
      ...data.data
    }
  } catch (error) {
    console.log('Next.js Error :', dayjs().format('YY-MM-DD HH:mm:ss'), `/ 列表数据获取失败：`, JSON.stringify(error))
  }
}

const getSchemeBreadcrumb = async (id: string) => {
  try {
    const data = await searchApi.getSchemeBreadcrumb(id)
    return {
      ...data.data
    }
  } catch (error) {
    console.log('Next.js Error :', dayjs().format('YY-MM-DD HH:mm:ss'), `/ 面包屑数据获取失败：`, JSON.stringify(error))
  }
}

const getSchemeSidebar = async (id: string) => {
  try {
    const data = await searchApi.getSchemeSidebar(id)
    return {
      ...data.data
    }
  } catch (error) {
    console.log('Next.js Error :', dayjs().format('YY-MM-DD HH:mm:ss'), `/ 侧边栏筛选数据获取失败：`, JSON.stringify(error))
  }
}

export async function getServerSideProps(context: any) {
  const { slug } = context.query
  const schemeId = slug[0].split("_s")[1]

  try {
    const [pageList, schemeBreadcrumb, schemeSidebar] = await Promise.all([
      getSchemeList(schemeId, { page: 1, perPage: 20 }),
      getSchemeBreadcrumb(schemeId),
      getSchemeSidebar(schemeId)
    ]);
    if (pageList && schemeBreadcrumb && schemeSidebar) {
      return {
        props: {
          pageList, schemeBreadcrumb, schemeSidebar
        }
      }
    } else {
      console.log('Next.js Error :', dayjs().format('YY-MM-DD HH:mm:ss'), `/ promise all：三个服务器端有数据为空`);
      return {
        notFound: true,
      }
    }
  } catch (error) {
    console.log('Next.js Error :', dayjs().format('YY-MM-DD HH:mm:ss'), `/ promise all：`, JSON.stringify(error));
    return {
      notFound: true,
    }
  }



}

const SchemePage = ({ pageList, schemeBreadcrumb, schemeSidebar }: Props) => {
  const [listInfo, setListInfo] = useState(pageList)
  // const [productList] = useState(pageList.pageList.items)
  const [productListClient, setProductListClient] = useState(pageList.pageList.items)
  const [breadCrumb] = useState(schemeBreadcrumb.breadCrumb)
  const [sidebar] = useState(schemeSidebar)
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(20)
  // const [total, setTotal] = useState(0)
  const [isFinsh, setIsFinsh] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)
  const [isFirst, setIsFirst] = useState(true)
  const router = useRouter();
  const [filterBarData, setFilterBarData] = useState<DAMNU_ENABLE>({})
  useEffect(() => {
    if (isFirst) {
      setIsFirst(false)
      return
    }
    getProductList()
  }, [pageSize, currentPage, filterBarData])

  const getProductList = async () => {
    setLoading(true)
    const { slug } = router.query;
    if (!slug) {
      return
    }
    const schemeId = slug[0].split("_s")[1]
    let params: any = {
      page: currentPage,
      perPage: pageSize,
    }
    // 遍历左侧对象
    for (const key in filterBarData) {
      if (Object.prototype.hasOwnProperty.call(filterBarData, key)) {
        const element = filterBarData[key];

        // 判断属于哪个类目下，传参有所不同
        if (fillterBarDictionary.getValueByKey(element.key) === 1) {
          params.sortBy = element.sortBy
          params.sortDirection = element.direction
        }
        if (fillterBarDictionary.getValueByKey(element.key) === 2) {
          params.minPrice = element.minPrice
          params.maxPrice = element.maxPrice
        }
        if (fillterBarDictionary.getValueByKey(element.key) === 3) {
          params.brand = element.name
        }
        if (fillterBarDictionary.getValueByKey(element.key) === 4) {
          params.categoryID = element.categoryID
        }


        // 没字典特殊的统一处理
        if (!fillterBarDictionary.getValueByKey(element.key)) {
          params.categoryID = element.categoryID
        }
      }
    }
    const productInfo = await getSchemeList(schemeId, params)
    setListInfo(productInfo)
    setProductListClient(productListClient.concat(productInfo.pageList.items))
    // setTotal(productInfo.pageList.total)
    setIsFinsh(productInfo.pageList.items.length < pageSize)
    setIsEmpty(productInfo.pageList.items.length == 0)
    setLoading(false)
  }


  // 左侧筛选处理
  const filterBarChange = (item: any) => {
    let data = filterBarData

    // 重复选需要删除
    if (JSON.stringify(data[item.key]) == JSON.stringify(item)) {
      delete data[item.key]
    } else {
      // Price Range与Hot Brands是相互冲突的
      // if (fillterBarDictionary.getValueByKey(item.key) != 1) {
      //   for (const key in data) {
      //     if (Object.prototype.hasOwnProperty.call(data, key)) {
      //       // 判断不为custom-filtering的都互斥
      //       fillterBarDictionary.getValueByKey(key) != 1 && delete data[key]
      //     }
      //   }
      // }
      data = { ...filterBarData, [item.key]: item }
    }

    setProductListClient([])
    setCurrentPage(1)
    setIsFinsh(false)
    setFilterBarData({ ...data })
  }

  const handleScroll = () => {

    const targetElement = document.getElementById("product-list-id")

    if (targetElement) {
      // 获取目标元素的位置信息
      const targetElementRect = targetElement.getBoundingClientRect();

      // 获取窗口的滚动位置
      const scrollPosition = window.scrollY || window.pageYOffset;

      // 判断窗口是否已经移动到目标元素底部
      if (scrollPosition + window.innerHeight >= targetElementRect.bottom + scrollPosition) {
        // 在这里触发加载事件
        if (!loading && !isFinsh) {
          window.scrollBy(0, -100); // 向上滚动一点，避免触底状态持续
          setCurrentPage(currentPage + 1)
        }
      }
    }
  };

  const itemListElement = breadCrumb.map((item: any, number: number) => {
    return {
      "@type": "ListItem",
      "position": number + 2,
      "name": item.name,
      "item": item.url
    }
  })
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.bestdeals.co.nz/"
      },
      ...itemListElement
    ]
  };
  return (
    <>
      <Head>
        <title>{listInfo.scheme.title || `Online Shopping in New Zealand: Discount Store - BestDeals.co.nz`}</title>
        <meta name="keywords" content={listInfo.scheme.metaKeywords || `best deals nz, bestdeals nz, best deals, bestdeals, bestdeals.co.nz, best deals new zealand`}></meta>
        <meta name="description" content={listInfo.scheme.metaDescription || `Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout >
        <div className={`${styles['scheme-box']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          {/* 面包屑 */}
          {
            !!(breadCrumb && breadCrumb.length) &&
            <BreadCrumEle BreadList={breadCrumb}></BreadCrumEle>
          }

          {/* 商城特色介绍 */}
          {/* <div className={styles['shop-info-box']}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div> */}

          <div className={styles['content-box']}>
            <div className={styles['left']}>
              <FilterBarScheme onChange={filterBarChange} filterBarData={filterBarData} sidebarData={sidebar} />

            </div>

            <div className={styles['right']}>
              {
                !!(listInfo.scheme && listInfo.scheme.logoUrl)
                &&
                <div className={styles['banner-box']}>
                  <Image src={listInfo.scheme.logoUrl} preview={false} width="100%" alt="banner" />
                </div>
              }
              <InfiniteScroll
                dataLength={productListClient.length}
                next={() => { }}
                hasMore={!isFinsh}
                onScroll={handleScroll}
                endMessage={
                  <>
                    {/* {
                  !isEmpty
                  &&
                  <p style={{ textAlign: 'center' }}>
                    <b>Yay! You have seen it all</b>
                  </p>
                } */}
                  </>
                }
                loader={
                  <>
                    {
                      loading
                      &&
                      <p style={{ textAlign: 'center' }}>
                        loading...
                      </p>
                    }
                  </>
                }
              >
                <div className={styles['product-list']} id="product-list-id">
                  {
                    productListClient.length > 0
                      ?
                      productListClient.map((item: any) => (
                        <div className={styles['product-list-item']} key={item.productID}>
                          <GoodsComponentWithDiscountNew {...item} imgUrl={item.filename} productName={item.name} />
                        </div>
                      ))
                      :
                      <>
                        {
                          (isEmpty && !loading)
                            ?
                            <Empty style={{ 'flexBasis': '100%' }} />
                            :
                            <Skeleton active />
                        }
                      </>
                  }
                  <div className={styles['product-list-item']}></div>
                  <div className={styles['product-list-item']}></div>
                  <div className={styles['product-list-item']}></div>
                </div>
              </InfiniteScroll>

              <GoogleADSense />
            </div>
          </div>
        </div>
        <GoogleOneTap />
      </DefaultLayout>
      <Script
        type="application/ld+json"
        id="breadcrumb-schema"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  )
}

export default SchemePage;
